import React from 'react'
import Footer from "../Components/Footer"

const Contact = () => {
  return (
    <>
    <div name='contact' className='bg-white w-full h-full min-h-[calc(100vh-228px)] flex justify-start items-end p-4 pt-20' >
        {/* <form method='POST' action="https://getform.io/f/16021ae9-5e90-4116-adc3-dfd6212ecba5" className='flex flex-col max-w-[600px] w-full mx-auto'> */}
        {/*herotofu from kayrakkum.com */}
        <form method='POST' action="https://public.herotofu.com/v1/547ef590-ecac-11ed-b2e2-c10354b56774" className='flex flex-col max-w-[600px] w-full mx-auto'> 

            <div className='pb-8'>
                <p className='text-4xl font-bold inline border-b-4 border-gray-100 text-gray-700'>Напишите нам</p>
                <p className='text-gray-700 py-4'>// отправьте ваше сообщение через эту форму</p>
            </div>
            <input className='p-2 bg-gray-100' type="text" placeholder='Ваше имя' name='name' required/>
            <input className='my-4 p-2 bg-gray-100' type="email" placeholder='email' name='email' required/>
            <textarea name="message" className='p-2 bg-gray-100' rows="10" placeholder='введите текст сообщения' required></textarea>
            <button className='text-white border-2 font-semibold bg-[#6C94D1] hover:bg-white hover:text-gray-500 hover:border-[#6C94D1] px-4 py-3 mx-auto my-8 flex items-center'>Отправить</button>
        </form>
    </div>
    <Footer />
    </>
  )
}

export default Contact